export default "__VITE_ASSET__Bh_MMFHW__"